import React from "react";

const About = () => {
  return (
    <div>
      <h1>App for Github searchUsers</h1>
    </div>
  );
};

export default About;
